import { render, staticRenderFns } from "./addressManage.vue?vue&type=template&id=7128cc1d&scoped=true&"
import script from "./addressManage.vue?vue&type=script&lang=js&"
export * from "./addressManage.vue?vue&type=script&lang=js&"
import style0 from "./addressManage.vue?vue&type=style&index=0&id=7128cc1d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7128cc1d",
  null
  
)

component.options.__file = "addressManage.vue"
export default component.exports